import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import * as ElementPlusIcons from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import './assets/reset.css'
import './assets/font.css'
// import VConsole from 'vconsole'

// const vConsole = new VConsole()
const app = createApp(App);

for(const [name, comp] of Object.entries(ElementPlusIcons))
{
  app.component(name, comp);
}

app.use(ElementPlus);
app.use(store);
app.use(router);
// app.use(vConsole);
app.mount('#app');
